export const arrayUniqueByKey = (key, array) => [...new Map(array.map(item =>
  [item[key], item])).values()];
